// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";

// core components/views for Admin layout
import DashboardPage from "views/Dashboard";
import ReportPage from "views/Reports/Reports.js";

import Users from "views/Users";
import UserOperations from "views/Users/AddEdit";

import Vehicles from "views/Vehicles";
import DieselSupervisors from "views/DieselSupervisors";
import StorageSupervisor from "views/StorageSupervisor";
import VehicleOperations from "views/Vehicles/AddEdit";
import DriveEtaIcon from "@material-ui/icons/DriveEta";

import Equipments from "views/Equipments";
import EquipmentOperations from "views/Equipments/AddEdit";
import ManageEquipmentTypes from "views/Equipments/manageEquipments";
import AcUnitIcon from "@material-ui/icons/AcUnit";

import Villages from "views/Villages";

import ProjectOperations from "views/Projects/AddEdit";
import ManageProject from "views/Projects";

import TeamOperations from "views/Teams/AddEdit";
import ManageJobs from "views/Jobs";
import FilterListIcon from "@material-ui/icons/FilterList";

import ViewProject from "views/Projects/viewProject";
import FarmList from "views/Farmers";
import HomeIcon from "@material-ui/icons/Home";
import WorkIcon from "@material-ui/icons/Work";
import StorageIcon from "@material-ui/icons/Storage";

import States from "views/States";
import ApartmentIcon from "@material-ui/icons/Apartment";

import Cities from "views/Cities";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";

import WorkLog from "views/WorkLog";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: Dashboard,
    component: DashboardPage, // <----
    layout: "/admin",
    canShowInSideBar: true,
  },

  {
    path: "/users",
    name: "Users List",
    icon: Person,
    component: Users,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/users/operations/:user_id?",
    name: "Add User",
    icon: Person,
    component: UserOperations,
    layout: "/admin",
  },
  {
    path: "/vehicle",
    name: "Vehicles",
    icon: DriveEtaIcon,
    component: Vehicles,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/vehicles/operations/:vehicle_id?",
    name: "Add Vehicle",
    component: VehicleOperations,
    layout: "/admin",
  },
  {
    path: "/equipments",
    name: "Equipments",
    icon: AcUnitIcon,
    component: Equipments,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/equipments/operations/:equipment_id?",
    name: "Add equipments",
    component: EquipmentOperations,
    layout: "/admin",
  },
  {
    path: "/equipments/manage",
    name: "Manage equipments",
    component: ManageEquipmentTypes,
    layout: "/admin",
  },
  {
    path: "/project",
    name: "Create / Manage Projects",
    icon: StorageIcon,
    component: ManageProject,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/project/operations/:project_id?",
    name: "Add Project",
    component: ProjectOperations,
    layout: "/admin",
  },
  // {
  //   path: "/teams",
  //   name: "Manage Teams",
  //   icon: PeopleIcon,
  //   component: ManageTeams,
  //   layout: "/admin",
  //   canShowInSideBar: true,
  //   isExact: true,
  // },
  {
    path: "/jobs",
    name: "Jobs Overview",
    icon: WorkIcon,
    component: ManageJobs,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/diesel_supervisors",
    name: "Diesel Supervisors",
    icon: FilterListIcon,
    component: DieselSupervisors,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/storage_supervisors",
    name: "Storage Supervisors",
    icon: FilterListIcon,
    component: StorageSupervisor,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },

  {
    path: "/reports",
    name: "Reports",
    icon: Dashboard,
    component: ReportPage,
    layout: "/admin",
    canShowInSideBar: true,
  },
  {
    path: "/jobs/:project_id/:sector_officer_id",
    name: "Manage Jobs",
    component: ManageJobs,
    isExact: true,
    layout: "/admin",
  },
  {
    path: "/teams/operations/:action/:project_id?/:sector_officer_id?",
    name: "Add Team",
    component: TeamOperations,
    isExact: true,
    layout: "/admin",
  },
  {
    path: "/project/view/:project_id?",
    name: "View Project",
    component: ViewProject,
    layout: "/admin",
  },
  {
    path: "/farmer/:project_id?/:team_id?/:village_id?",
    name: "View Farms",
    component: FarmList,
    layout: "/admin",
  },
  {
    path: "/worklog/:user_id",
    name: "User Worklog",
    component: WorkLog,
    layout: "/admin",
  },

  {
    path: "/states",
    name: "States",
    icon: ApartmentIcon,
    component: States,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/districts",
    name: "Districts",
    icon: EmojiTransportationIcon,
    component: Cities,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
  {
    path: "/villages",
    name: "Villages",
    icon: HomeIcon,
    component: Villages,
    layout: "/admin",
    canShowInSideBar: true,
    isExact: true,
  },
];

export default dashboardRoutes;
